// @ts-nocheck
import styled from 'styled-components';

export const ControlPanelStyle = styled.div`
  .mapControlPanel {
    background-color: ${props => props.theme.uiColors.background01};

    .buttonsContainer {
      width: 40px;

      .verticalTabsButton {
        padding: 0;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          color: ${props => props.theme.uiColors.toggleButtonSelectedText} ;
          background-color: ${props => props.theme.uiColors.toggleButtonSelectedBackground};
        }

        .icon {
          width: auto;
          font-size: ${props => props.theme.fontSizeM};
        }
      }
    }
    .componentTitle {
      background-color: ${props => props.theme.uiColors.background01};
      color: ${props => props.theme.uiColors.textTitle};
      height: 55px;
      text-transform: none;
      .icon {
        display: none;
      }
    }
    .componentContent {
      background-color: ${props => props.theme.uiColors.tableFullPaginationBg};
    }
  }
`;
